export default function (context) {
  // https://link.xsolla.com/6yRp3h5G
  // https://link.xsolla.com/zKFwaYJs

  context.app.router.beforeEach((to, from, next) => {
    const campaigns = ['5c13621939b6e', '5f6bb3280e9a6']

    if (!to.name.startsWith('offer-lenovo') &&
      to.query.utm_source === 'eJlayuzO' &&
      campaigns.includes(to.query.utm_campaign)) {
      next(context.localeRoute({
        name: 'offer-lenovo',
        query: to.query
      }))
    } else {
      next()
    }
  })
}
